import { call, takeEvery } from 'redux-saga/effects';
import { LOGOUT_USER } from '../../actions/actionTypes';

export function* requestLogoutUserAsync() {
    const domain = window.location.host;
    const fetchResponse = yield call(fetch, `https://${domain}/logout/`);
    if (fetchResponse.status === 200 && fetchResponse.redirected) {
        window.location = fetchResponse.url;
    }
}

export default function* watchRequestLogoutUser() {
    yield takeEvery(LOGOUT_USER, requestLogoutUserAsync);
}
